var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafetyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 112.5,
    height: 119.988,
    viewBox: "0 0 112.5 119.988",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-shield-alt",
    "data-name": "Icon awesome-shield-alt",
    d: "M106.711,19.613l-45-18.75a11.285,11.285,0,0,0-8.648,0l-45,18.75A11.238,11.238,0,0,0,1.125,30c0,46.523,26.836,78.68,51.914,89.133a11.285,11.285,0,0,0,8.648,0C81.773,110.762,113.625,81.863,113.625,30A11.253,11.253,0,0,0,106.711,19.613ZM57.4,104.6l-.023-89.3L98.6,32.48c-.773,35.484-19.242,61.2-41.2,72.117Z",
    transform: "translate(-1.125 -0.002)",
    fill: "#1fbdfc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafetyIcon);
export default __webpack_public_path__ + "static/media/safety-icon.d40ecbcf2ea34b117ea2d036cb2db15b.svg";
export { ForwardRef as ReactComponent };